/**
 * Non-tracking device fingerprint for the `deviceFingerprint` field required
 * by POST /final. This is a tamper-evidence aid, not a security boundary —
 * the server already knows `who` via the bearer token. A short hash of stable
 * browser properties is enough to flag "finalized from a different device
 * than the visit was recorded on" later.
 */

function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input)
  return crypto.subtle.digest('SHA-256', bytes).then((buf) => {
    const arr = Array.from(new Uint8Array(buf))
    return arr.map((b) => b.toString(16).padStart(2, '0')).join('')
  })
}

export async function getDeviceFingerprint(): Promise<string> {
  const ua = navigator.userAgent
  const lang = navigator.language
  const platform = navigator.platform ?? ''
  const screenSig = `${window.screen.width}x${window.screen.height}@${window.devicePixelRatio ?? 1}`
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone ?? ''
  const raw = `${ua}|${lang}|${platform}|${screenSig}|${tz}`
  // 16 hex chars (64-bit) is plenty for tamper-evidence and keeps the column short.
  const hash = await sha256Hex(raw)
  return hash.slice(0, 16)
}
